export default "../css/fd012577d3f8e88a814927de340b11da.ttf";